// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/cookies.sass
// module id = 200
// module chunks = 0